import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { DataGrid, GridColDef, GridRenderCellParams, GridSelectionModel } from '@mui/x-data-grid';
import { appRoutes } from 'app/app-routes';
import SavedSearchIcons from 'common/components/SavedSearchIcons';
import { searchParamTools } from 'common/tools/search-param-tools';
import { User } from 'graphql/generated';
import sellLogo from 'images/sell2.png';
import _ from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { cacheSelectors } from 'redux/cache.slice';
import { RootState } from 'redux/root-reducer';
import WsFlexbox from 'stories/layout/WsFlexbox';
import WsInfoFrame from 'stories/layout/WsInfoFrame';

interface ActionCol {
  itemId: string;
  searchParams: string;
  user?: User;
}

interface GridObj {
  id: string;
  name: string;
  dateAdded: string;
  actions: ActionCol;
}

const SavedSearches = () => {
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => cacheSelectors.user(state));

  const [skipEffect, skipEffectTo] = useState(false);
  const [data, dataTo] = useState<GridObj[]>([]);
  const gridHeight = 505;
  const gridWidth = 860;

  const loadSearch = (searchParams: string) => {
    // console.log('load search', searchParams);
    navigate(`${appRoutes.search}?${searchParamTools.dbToUrlParams(searchParams)}`);
  };

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'name',
      headerName: 'Search Parameters',
      width: 360,
      editable: false,

      // cellClassName:
    },
    {
      field: 'dateAdded',
      headerName: 'Date Added',
      width: 120,
      editable: false,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 80,
      align: 'center',
      editable: false,
      sortable: false,
      renderCell: (params: GridRenderCellParams<ActionCol>) => (
        <WsFlexbox gap={1}>
          <IconButton
            color="primary"
            sx={{ padding: 0 }}
            aria-label="savedSearch"
            component="span"
            onClick={() => loadSearch(params.value.searchParams)}
          >
            <SavedSearchIcon sx={{ fontSize: '24px' }} />
          </IconButton>
          <SavedSearchIcons
            itemId={params.value.itemId}
            value={true}
            deleteMode={true}
            user={params.value.user}
            toggleFn={skipEffectTo}
          />
        </WsFlexbox>
      ),
    },
  ];

  useEffect(() => {
    if (!skipEffect) {
      skipEffectTo(true);
      if (user?.savedSearches?.length) {
        dataTo(
          user.savedSearches.map(x => ({
            id: x.id,
            name: x.name,
            dateAdded: moment(x.dateAdded).format('MMM DD, YYYY'),
            actions: {
              itemId: x.id,
              searchParams: x.searchParams,
              user: user!,
            },
          })),
        );
      } else dataTo([]);
    }
  }, [user, skipEffect]);

  return (
    <Grid container justifyContent="center" sx={{ flexGrow: 1 }}>
      <Grid container sx={{ width: gridWidth }}>
        <Grid item xs={12}>
          <Typography variant="h4" color="primary">
            SavedSearches
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <img src={sellLogo} alt="sell" width="100%" />
        </Grid>
        <Grid container item xs={12}>
          <Grid container justifyContent="center">
            <WsInfoFrame
              width="80%"
              title="Saved Searches"
              icon={<SavedSearchIcon color="secondary" sx={{ position: 'relative', top: '4px' }} />}
            >
              <>
                {data.length ? (
                  <Box sx={{ height: gridHeight, width: '100%' }}>
                    <DataGrid
                      sx={{
                        columnHeaderCheckbox: {
                          color: 'red',
                        },
                        '& .MuiDataGrid-columnHeaderTitleContainer .MuiCheckbox-root': {
                          color: 'red',
                          display: 'none',
                        },
                      }}
                      rows={data}
                      columns={columns}
                      // getRowHeight={getRowHeight}
                      pageSize={5}
                      rowsPerPageOptions={[5]}
                      columnVisibilityModel={{ id: false }}
                      // onRowClick={onRowClick}
                      // onCellClick={onCellClick}
                      editMode="cell"
                      disableColumnFilter
                      disableColumnMenu
                      disableColumnSelector
                      disableDensitySelector
                    />
                  </Box>
                ) : (
                  <WsFlexbox padding={4} centered>
                    You do not have any saved searches.
                  </WsFlexbox>
                )}
              </>
            </WsInfoFrame>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SavedSearches;
